import React, { createContext, useContext, useState, useEffect } from 'react';
import { translations, formatPrice } from './i18n';

const LanguageContext = createContext(null);

const DEFAULT_LANG = 'it';
const DEFAULT_CURRENCY = 'EUR';

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem('ids_lang') || DEFAULT_LANG);
  const [currency, setCurrencyState] = useState(() => localStorage.getItem('ids_currency') || DEFAULT_CURRENCY);

  useEffect(() => { localStorage.setItem('ids_lang', lang); }, [lang]);
  useEffect(() => { localStorage.setItem('ids_currency', currency); }, [currency]);

  const t = (key) => (translations[lang] && translations[lang][key]) || translations.it[key] || key;
  const price = (amountEur) => formatPrice(amountEur, currency, lang);

  const setLang = (l) => setLangState(l === 'en' ? 'en' : 'it');
  const setCurrency = (c) => setCurrencyState(c === 'USD' ? 'USD' : 'EUR');

  return (
    <LanguageContext.Provider value={{ lang, currency, setLang, setCurrency, t, price }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useTranslation() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useTranslation must be inside LanguageProvider');
  return ctx;
}
